import "./Member_Card.css";

function Member_Card(props)
{
    return(
        <div className = "member_card">
            <img src = { "https://favapis.raganindustries.com" + props.member_details.member_photo } alt = "err" />
            <h1>{ props.member_details.member_name }</h1>
            <h2>{ props.member_details.member_post + " " + props.member_details.member_year }</h2>
            <p>{ props.member_details.member_description }</p>
        </div>
    )
}

export default Member_Card;